<template>
  <!-- Add Kiosk User Modal -->
  <div
    id="add_kiosk_user"
    class="modal custom-modal fade"
    role="dialog"
    ref="addKioskUserModal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Kiosk User</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="addkioskuserclose"
            @click="formClear()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Email <span class="text-danger">*</span></label
              >
              <input
                v-model="form.email"
                class="form-control"
                type="email"
                :class="{ 'is-invalid': clientError.includes('email') }"
                @change="handleChangeEvent('email')"
              />
              <span class="text-danger" v-if="clientError.includes('email')"
                >Email is required</span
              >
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Password <span class="text-danger">*</span></label
              >
              <input
                v-model="form.password"
                class="form-control"
                type="password"
                :class="{ 'is-invalid': clientError.includes('password') }"
                @change="handleChangeEvent('password')"
              />
              <span class="text-danger" v-if="clientError.includes('password')"
                >Password is required</span
              >
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Confirm Password <span class="text-danger">*</span></label
              >
              <input
                v-model="form.password_confirmation"
                class="form-control"
                type="password"
                :class="{
                  'is-invalid': clientError.includes('password_confirmation'),
                }"
                @change="handleChangeEvent('password_confirmation')"
              />
              <span
                class="text-danger"
                v-if="clientError.includes('password_confirmation')"
                >Confirm Password is required</span
              >
              <span
                class="text-danger"
                v-if="confirm_password_error && confirm_password_error != null"
                >{{ confirm_password_error }}</span
              >
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Office <span class="text-danger">*</span></label
              >
              <Field
                name="office_id"
                as="select"
                class="form-control"
                v-model="form.office_id"
                :class="{ 'is-invalid': clientError.includes('office_id') }"
                @change="handleChangeEvent('office_id')"
              >
                <option value="">Select Office</option>
                <option
                  v-for="office in officeList"
                  :key="office.office_id"
                  :value="office.office_id"
                >
                  {{ office.office_name }}
                </option>
              </Field>
              <div
                class="invalid-feedback"
                v-if="clientError.includes('office_id')"
              >
                Office is required
              </div>
            </div>

            <!-- Submit -->
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Add Kiosk User Modal -->

  <!-- Kiosk User Modal -->
  <div
    class="modal custom-modal fade"
    id="kiosk_user_modal"
    tabindex="-1"
    aria-labelledby="kioskUserModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title" id="kioskUserModalLabel">Kiosk Users</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="kioskusersclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered table-hover align-middle">
                  <thead class="table-light">
                    <tr>
                      <th>#</th>
                      <th>Email</th>
                      <th>Office</th>
                      <th>Created By</th>
                      <th>Updated By</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="kioskUsers.length === 0">
                      <td colspan="5" class="text-center text-muted">
                        No kiosk users found
                      </td>
                    </tr>
                    <tr v-for="(user, index) in kioskUsers" :key="user.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ user.email }}</td>
                      <td>{{ user.office ? user.office.office_name : "" }}</td>
                      <td>
                        {{
                          user.created_by
                            ? user.created_by.first_name +
                              " " +
                              user.created_by.last_name
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          user.updated_by
                            ? user.updated_by.first_name +
                              " " +
                              user.updated_by.last_name
                            : "-"
                        }}
                      </td>
                      <td>
                        <a
                          class="btn btn-sm btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#update_kiosk_password"
                          @click="openPasswordModal(user)"
                        >
                          Update Password
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Kiosk User Modal -->

  <!-- Update Password Modal -->
  <div
    id="update_kiosk_password"
    class="modal custom-modal fade"
    tabindex="-1"
    aria-hidden="true"
    ref="updateKioskUserModal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Password</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="updatekioskuserclose"
            @click="passwordFormClear()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <Form @submit="submitPassword">
            <div class="mb-3">
              <span>Email: </span>
              <span>
                <strong>
                  {{ selectedUser ? selectedUser.email : "" }}</strong
                ></span
              >
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Password <span class="text-danger">*</span></label
              >
              <input
                v-model="passwordForm.password"
                class="form-control"
                type="password"
                :class="{ 'is-invalid': clientError.includes('u_password') }"
                @change="handleChangeEvent('u_password')"
              />
              <span
                class="text-danger"
                v-if="clientError.includes('u_password')"
                >Password is required</span
              >
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Confirm Password <span class="text-danger">*</span></label
              >
              <input
                v-model="passwordForm.password_confirmation"
                class="form-control"
                type="password"
                :class="{
                  'is-invalid': clientError.includes('u_password_confirmation'),
                }"
                @change="handleChangeEvent('u_password_confirmation')"
              />
              <span
                class="text-danger"
                v-if="clientError.includes('u_password_confirmation')"
                >Confirm Password is required</span
              >
              <span
                class="text-danger"
                v-if="confirm_password_error && confirm_password_error != null"
                >{{ confirm_password_error }}</span
              >
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Update Password Modal -->
</template>

<script>
import { notification } from "ant-design-vue";
import axios from "axios";
import { Form, Field } from "vee-validate";

export default {
  components: { Form, Field },

  data() {
    return {
      form: {
        email: "",
        password: "",
        password_confirmation: "",
        office_id: "",
      },
      confirm_password_error: null,
      officeList: [],
      clientError: [],
      kioskUsers: [],
      selectedUser: null,
      passwordForm: {
        password: "",
        password_confirmation: "",
      },
    };
  },
  methods: {
    handleChangeEvent(target) {
      this.clientError = this.clientError.filter((item) => item !== target);
    },
    onSubmit() {
      this.clientError = [];
      this.confirm_password_error = null;
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      // Validation
      if (this.form.email === "") this.clientError.push("email");
      if (this.form.password === "") this.clientError.push("password");
      if (this.form.password_confirmation === "")
        this.clientError.push("password_confirmation");
      if (this.form.office_id === "") this.clientError.push("office_id");
      if (
        this.form.password !== "" &&
        this.form.password_confirmation !== "" &&
        this.form.password !== this.form.password_confirmation
      ) {
        this.confirm_password_error =
          "Password and Confirm Password not matching";
      }

      if (this.clientError.length > 0 || this.confirm_password_error != null) {
        loader.hide();
        return;
      }

      axios
        .post("/add-kiosk-user", this.form)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_SUCCESS_COLOR },
          });

          this.$refs.addkioskuserclose.click();

          this.formClear();
          this.closeModal();
          this.fetchKioskUsers();
        })
        .catch((error) => {
          loader.hide();
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_WARNING_COLOR },
          });
        });
    },
    fetchOffices() {
      axios
        .get("/office/all")
        .then((response) => {
          var token = window.localStorage.getItem("token");
          axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          this.officeList = response?.data?.data || [];
        })
        .catch((error) => {
          console.log("error in fetching employee", error);
        });
    },
    fetchKioskUsers() {
      axios
        .get("/kiosk-users")
        .then((response) => {
          var token = window.localStorage.getItem("token");
          axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          this.kioskUsers = response?.data?.data || [];
        })
        .catch((error) => {
          console.log("error in fetching employee", error);
        });
    },
    formClear() {
      this.form = {
        email: "",
        password: "",
        password_confirmation: "",
        office_id: "",
      };
      this.clientError = [];
      this.confirm_password_error = null;
    },
    passwordFormClear() {
      this.passwordForm = {
        password: "",
        password_confirmation: "",
      };
      this.clientError = [];
      this.confirm_password_error = null;
    },
    closeDialog() {
      this.$refs.addkioskuserclose.click();
      this.$refs.kioskusersclose.click();
      this.$refs.updatekioskuserclose.click();
    },
    openPasswordModal(user) {
      this.selectedUser = user;
    },
    closeModal() {
      document.body.classList.remove("modal-open");
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    },
    submitPassword() {
      this.clientError = [];
      this.confirm_password_error = null;
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      if (this.passwordForm.password === "")
        this.clientError.push("u_password");
      if (this.passwordForm.password_confirmation === "")
        this.clientError.push("u_password_confirmation");
      if (
        this.passwordForm.password !== "" &&
        this.passwordForm.password_confirmation !== "" &&
        this.passwordForm.password !== this.passwordForm.password_confirmation
      ) {
        this.confirm_password_error =
          "Password and Confirm Password not matching";
      }

      if (this.clientError.length > 0 || this.confirm_password_error != null) {
        loader.hide();
        return;
      }

      axios
        .post(
          `/kiosk-user/update-password/${this.selectedUser.id}`,
          this.passwordForm
        )
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_SUCCESS_COLOR },
          });

          this.$refs.updatekioskuserclose.click();

          this.passwordFormClear();
          this.fetchKioskUsers();
        })
        .catch((error) => {
          loader.hide();
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_WARNING_COLOR },
          });
        });
    },
  },
  mounted() {
    this.fetchOffices();
    this.fetchKioskUsers();
    if (this.$refs.addKioskUserModal) {
      this.$refs.addKioskUserModal.addEventListener(
        "hidden.bs.modal",
        this.formClear
      );
    }
    if (this.$refs.updateKioskUserModal) {
      this.$refs.updateKioskUserModal.addEventListener(
        "hidden.bs.modal",
        this.passwordFormClear
      );
    }
  },
};
</script>
